var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt',{attrs:{"src":require("@/assets/images/IMG_7742.jpg"),"title":_vm.$t('views.offer')}}),_c('brief-offer'),_c('info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }